import React from 'react';
import { Button, Card, Flex, Heading, Text, View } from '@aws-amplify/ui-react';

const ConfirmDialog = ({ isOpen, title, message, confirmText = 'Confirm', variant = 'destructive', onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <View
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      backgroundColor="rgba(0, 0, 0, 0.5)"
      display="flex"
      justifyContent="center"
      alignItems="center"
      style={{ zIndex: 1000 }}
    >
      <Card variation="elevated" padding="1.5rem" maxWidth="500px" width="90%">
        <Heading level={4} marginBottom="1rem">{title}</Heading>
        <Text marginBottom="1.5rem">{message}</Text>
        <Flex gap="1rem" justifyContent="flex-end">
          <Button onClick={onCancel}>Cancel</Button>
          <Button variation={variant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </Flex>
      </Card>
    </View>
  );
};

export default ConfirmDialog;
